import styled from 'styled-components';
import { Link } from 'react-router-dom';

const FormTitle = styled.h1`
    color: #151a43;
    font-weight: 500;
    font-family: Lato;
    font-size: 24px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: normal;
`

const FormSubTitle = styled.h3`
    font-size: 16px;
    color: #414670;
    opacity: 0.5;
    margin-top: 6px;
    margin-bottom: 30px;
`

const FormSection = styled.form`
    display: flex;
    background-color: #ffffff;
    height: 100%;
    height: ${props => props.height || '100%'};
    border-top-left-radius: 11px;
    border-bottom-left-radius: 11px;
    flex-direction: column;
    ${({ flex }) => flex && `
    flex: 6;
  `}
`

const FieldGroup = styled.div`
	margin-top: 35px;
`

const StyledLink = styled(Link)`
	display: flex;
	font-size: 16px;
	font-weight: normal;
	font-style: normal;
	text-decoration: none;
    color: rgba(21, 26, 67, 0.57) !important;
    margin-top: 21px;
    margin-left: -10px;
    &:hover {
        text-decoration: underline;
        color: #414670 !important;
        outline: none;
    }
	&:focus, &:visited, &:link, &:active {
        text-decoration: none;
        outline: none;
	}
`
const FieldLabel = styled.div`
	font-size: 14px;
	color: #414670;
	opacity: 0.8;
	margin-bottom: 6px;
`

const RefreshButton = styled.div`
    display: flex;
    margin-top: 40px;
    font-size: 14px;
    align-items: center;
    cursor: pointer;
    & .SVGInline {
        margin-right: 10px;
        height: 15px;
    }
    &:hover {
        span.txt {
            text-decoration: underline;
        }
    }
`

const NextBtn = {
    "marginTop": "16px",
    "marginLeft": "-10px"
}

export {
	FormTitle,
	FormSubTitle,
	FormSection,
	StyledLink,
	FieldGroup,
	FieldLabel,
    RefreshButton,
    NextBtn
}
